module.exports = __webpack_public_path__ + "static/media/terms.9f13843e.svg";